import PropTypes from 'prop-types';

const obligationPropTypes = PropTypes.shape({
  companyCode: PropTypes.string,
  legalEntity: PropTypes.string,
  countryCode: PropTypes.string,
  countryTaxType: PropTypes.string,
  countryTaxTypeDescription: PropTypes.string,
  stateMinimumTax: PropTypes.number,
  stateApportionmentRate: PropTypes.number,
  statePrePostNOL: PropTypes.string,
  federalFTCLimit: PropTypes.string,
  NOL: PropTypes.string,
  recordVA: PropTypes.string,
  overrideTaxRate: PropTypes.number,
  overrideDeferredTaxRate: PropTypes.number,
  currentTaxRate: PropTypes.number,
  deferredTaxRate: PropTypes.number,

  period: PropTypes.shape({
    name: PropTypes.string,
  }),
});

export default obligationPropTypes;
